import type { PullRequestDetail, PullRequestLifecycleAction } from "@afar-research/contracts";

export function lifecycleAllowed(detail: PullRequestDetail, action: PullRequestLifecycleAction) {
  const caps = detail.capabilities;
  const permissions = detail.viewerPermissions;
  if (
    action.kind === "merge" ||
    action.kind === "enable-auto-merge" ||
    action.kind === "disable-auto-merge"
  )
    return (
      detail.state === "open" &&
      caps.actions.includes(action.kind) &&
      permissions.actions.includes(action.kind) &&
      (action.kind === "disable-auto-merge" ||
        (!detail.isDraft &&
          caps.mergeMethods.includes(action.method) &&
          detail.mergeCapabilities[action.method]))
    );
  if (action.kind === "request-reviewers")
    return caps.reviewers.request && permissions.requestReviewers;
  const operation = action.kind === "lifecycle" ? action.operation : "update-branch";
  return (
    caps.actions.includes(operation) &&
    permissions.actions.includes(operation) &&
    (action.kind !== "update-branch" ||
      (caps.updateMethods?.includes(action.method) &&
        permissions.updateMethods?.includes(action.method)))
  );
}
